<template>
  <div class="accordion">
    <slot></slot>
  </div>
</template>

<script>
  export default {
    name: 'SAccordion'
  }
</script>

<style lang="scss">
.accordion {
  padding-left: 24px;
  padding-right: 24px;
  border: 1px solid $grayBorder;
  border-radius: 12px;

  @media (max-width: $breakpoint-md) {
    padding: 8px 16px;
  }
}
</style>